import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useActiveOrganization } from '@/features/organizations/public';
import { MemberRole } from '@/core/constants/roles';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { TimeOffDateRangeQueryParams } from '../types';

/** Owner/Admin only. `from`/`to` capped at 366 days (`DateRangeTooWide` otherwise). */
export function useAdminTimeOffSummary(params: TimeOffDateRangeQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { activeOrganization } = useActiveOrganization();
  const isAdmin =
    activeOrganization?.role === MemberRole.Owner || activeOrganization?.role === MemberRole.Admin;

  return useQuery({
    queryKey: TIME_OFF_KEYS.adminSummary(orgId, params),
    queryFn: ({ signal }) => timeOffService.getAdminSummary(params, signal),
    staleTime: 60_000,
    enabled: !!orgId && isAdmin && !!params.from && !!params.to,
  });
}
